import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { PhysicianPortalEventType as _PhysicianPortalEventType } from '../PhysicianPortalEventType';

const _type = Symbol();

export class PhysicianPortalEventType extends BaseElement {
	constructor() {
		super();
		this.type = null;
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: block;
					padding: 0.5em;
				}
				.container {
					display: flex;
					flex-flow: row nowrap;
				}
				.container > * {
					flex: 1;
				}
				.container > .checkbox {
					flex: 0;
					margin-right: 0.5em;
				}
				select {
					background: var(--theme-background-hover, white);
				}
			`
		];
	}
	get type() {
		return this[_type];
	}
	set type(v) {
		if(v !== null && !(v instanceof _PhysicianPortalEventType))
			throw new TypeError('type must be an instance of PhysicianPortalEventType.');
		this[_type] = v;

		this.requestUpdate();
	}
	get checked() {
		return this.shadowRoot.querySelector('input[type="checkbox"]').checked;
	}
	set checked(v) {
		if(typeof v !== 'boolean')
			throw new TypeError('checked must be a boolean.');
		this.shadowRoot.querySelector('input[type="checkbox"]').checked = v;
	}
	render() {
		return html`
			<div class="container">
				<div class="checkbox">
					<input id="toggle" @change="${() => this.emit('check')}" type="checkbox" />
					<label for="toggle"></label>
				</div>
				<div>
					<label for="toggle"><strong>${this.type.name}</strong></label>
					<div>${this.type.description}</div>
				</div>
			</div>
		`;
	}
}

customElements.define('pp-event-type', PhysicianPortalEventType);